import AnimationCards from "./AnimationCards";

const Index = () => {
  return (
    <div>
      <AnimationCards />
    </div>
  );
};

export default Index;
